import { useEffect } from "react";
import { Navigate, useLocation, useParams } from "react-router-dom";

// Old Shopify theme addresses (still in Google and old links) -> matching pages on this site
const PRODUCT_TO_PATH = [
  ["muscle-mango", "/flavours/mango"],
  ["watermelon-warrior", "/flavours/watermelon"],
  ["cherry-crusher", "/flavours/cherry"],
  ["iced-razz", "/flavours/razz"],
  ["mandarin-madness", "/flavours/mandarin"],
];

const productPath = (handle = "") => {
  const flavour = PRODUCT_TO_PATH.find(([h]) => handle.startsWith(h));
  if (flavour) return flavour[1];
  const size = handle.startsWith("build") && handle.match(/(12|24|50)/)?.[1];
  return size ? `/build?size=${size}` : "/shop";
};

const PAGE_TO_PATH = { about: "/story", "about-us": "/story", "our-story": "/story", contact: "/faq", faq: "/faq", faqs: "/faq",
  "store-locator": "/stores", stores: "/stores", "where-to-buy": "/stores", nutrition: "/nutrition", reviews: "/reviews" };

export const LegacyProduct = () => <Navigate to={productPath(useParams().handle)} replace />;
export const LegacyPage = () => <Navigate to={PAGE_TO_PATH[useParams().page] || "/"} replace />;
export const LegacyShop = () => <Navigate to="/shop" replace />;
export const LegacyAccount = () => {
  const { pathname } = useLocation();
  useEffect(() => { window.location.replace(`https://shop.swolebears.ca${pathname}`); }, [pathname]);
  return null;
};
